export default __webpack_public_path__ + "static/media/emotionaljudge.e8b3a97c.svg";